/**
 * Encounters feature auto-registration and exports
 *
 * This module automatically registers the encounters feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { encountersFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(encountersFeature);

// Export page components (main entry points for routes)
export { EncounterPage, default as EncounterPageDefault } from './EncounterPage';
// Export components (for potential reuse - following dashboard pattern)
export { EncounterFormProvider, EncounterView } from './components';

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';

// Export constants
export * from './constants';

// Export hooks
export { useActiveWorkflowEncounter } from './hooks/useActiveWorkflowEncounter';
export { useDebouncedWorkingBillingClaim } from './hooks/useDebouncedWorkingBillingClaim';
export type { BillingClaimUpdate } from './hooks/useDebouncedWorkingBillingClaim';
export { useEncounterWorkflowGuard } from './hooks/useEncounterWorkflowGuard';
export type { RecordingInputsResult } from './hooks/useRecordingInputs';
export { useRecordingInputs } from './hooks/useRecordingInputs';
export { useSaveEncounter } from './hooks/useSaveEncounter';
